export const selectDefaultStyles = {
    control: (base, { isDisabled }) => (localStorage.locales_theme === "dark" ? {
        ...base,
        minHeight: 0,
        height: '2.3em',
        backgroundColor: isDisabled ? "#F5F5F5" : "#232630",
        boxShadow: "none",
        border: isDisabled ? "1px solid #DBDBDB" : "none",
        paddingTop: 1,
        paddingBottom: 1,
        pointerEvents: "auto",
        cursor: isDisabled ? "not-allowed" : "default",
        alignContent: 'center'
    } : {
        ...base,
        minHeight: 0,
        height: '2.3em',
        backgroundColor: isDisabled ? "#F0F0F0" : "#FFF",
        boxShadow: "none",
        border: isDisabled ? "1px solid #DBDBDB" : "none",
        paddingTop: 1,
        paddingBottom: 1,
        pointerEvents: "auto",
        cursor: isDisabled ? "not-allowed" : "default",
        alignContent: 'center'
    }),
    container: (base, { isFocused, isDisabled }) => ({
        ...base,
        borderRadius: "4px",
        border: isDisabled ? "1px solid #F5F5F5" : (isFocused ? `1px solid ${getColorByTheme()}` : "1px solid #DEDEDE"),
        width: '100%',
        ':hover' : {
            border: isDisabled ? "1px solid #F5F5F5" : (isFocused ? `1px solid ${getColorByTheme()}` : "1px solid #B5B5Bf")
        }
    }),
    singleValue: (base) => ({
        ...base,
        color: 'inherit'
    }),
    multiValueLabel: (base) => ({
        ...base,
        background: "#F0F0F0",
        color: 'inherit'
    }),
    multiValueRemove: (base) => ({
        ...base,
        ':hover': {
            color: '#e74360',
            backgroundColor: "#f3a1af"
        }
    }),
    dropdownIndicator: (base, { isDisabled }) => ({
        ...base,
        padding: '4px',
        visibility: isDisabled ? "hidden" : "visible"
    }),
    indicatorSeparator: base => ({
        ...base,
        visibility: "hidden"
    }),
    clearIndicator: base => ({
        ...base,
        padding: '4px'
    }),
    indicatorsContainer: base => ({
        ...base,
        padding: '4px'
    }),
    valueContainer: base => ({
        ...base,
        padding: '0px 6px',
    }),
    input: base => ({
        ...base,
        margin: 0,
        padding: 0
    }),
    menu: base => (localStorage.locales_theme === 'dark' ? {
        ...base,
        backgroundColor: "#27292d",
        marginTop: 0
    } : {
            ...base,
            marginTop: 0,
            zIndex: 1300

        }),
    option: (base, { isFocused, isSelected }) => (localStorage.locales_theme === 'dark' ? {
        ...base,
        backgroundColor: isSelected ? "#F0F0F0" : isFocused ? "#4a4a4a" :
            null,
        color: isSelected ? "inherit" : ""
    } : {
            ...base,
            backgroundColor: isSelected ? "#F0F0F0" : isFocused ? "#fbfbfb" : "#fff",
            color: isSelected ? "inherit" : ""
        })
};

function getColorByTheme() {
    switch (localStorage.locales_theme) {
        case "blue": return "#10C9D3";
        case "red": return "#E74360";
        case "dark": return "#00c59e"
        default: return "#DEDEDE";
    }
}